import React, { useEffect, useState } from 'react'

const ApptDetailsWithQuery = ({ webquotecontrol, onlyDisplayThisStopType }) => {
    
    const [loading, setLoading] = useState(true);
    const [apptDetails, setApptDetails] = useState(null);

    useEffect(() => {
        if (webquotecontrol) {
            const fetchApptDetails = async () => {
                const details = await getApptDetails(webquotecontrol);
                setApptDetails(details);
                setLoading(false);
            };

            fetchApptDetails();
        }
    }, [webquotecontrol]);

    if (!webquotecontrol) { return null; }

    const getApptDetails = async (webquotecontrol) => {
        setLoading(true);
        let url = `https://api.shippersedge.com/schedule/events/?webquotecontrol=` + webquotecontrol

        let response = await fetch(url, {
            method: 'GET',
            headers: {
                'x-api-Key': 'vdhy8wwjUJrwhxFpfuECTiAW'
            }
        })

        let data = await response.json()
        return data
    }



    if (loading) {
        return <div>Checking appointment(s)...</div>
    }

    if (apptDetails?.length) {
        return (
            apptDetails.map((appt) => {
                let timeInString = ''
                let timeIn = new Date(appt?.timeIn)
                // convert to local time
                timeInString = timeIn.toLocaleString('en-US', { timeZone: 'UTC' })
                if (onlyDisplayThisStopType && appt?.type !== onlyDisplayThisStopType) {
                    return null
                } 
                return (
                    <div className="alert alert-success border-dark" title="Appointment Scheduled">
                        <small className="text-muted" style={{ fontSize: "12px" }}>{appt?.type} Appointment Scheduled</small><br />
                        {timeInString}<br />
                        {appt?.dockLocationName} Dock: {appt?.dockName} <br />
                        <small className="text-muted" style={{ fontSize: "12px" }}>Id {appt?.id}</small>
                    </div>
                )
            })
        )
    }

    return (
        null
    )
}

export default ApptDetailsWithQuery